import { Navigate, useLocation } from 'react-router-dom';

// The old sign-in URL; sign-in now lives at /welcome.
function SignIn() {
  const { search } = useLocation();
  return <Navigate to={`/welcome${search}`} replace />;
}

export default SignIn;
